// extracted by mini-css-extract-plugin
export default {"container":"CustomerCatalog_container__JoH5W","toast":"CustomerCatalog_toast__Qrsjf","toastIn":"CustomerCatalog_toastIn__SUhjX"};